module.exports = __webpack_public_path__ + "img/2012-12-14 20.08.03.12a14ec4.jpg";